import { useEffect } from "react";

interface LoadingSpinnerProps {
  size?: "small" | "medium" | "large";
  className?: string;
}

export const LoadingSpinner = ({ size = "medium", className }: LoadingSpinnerProps) => {
  const sizeMap = {
    small: "20px",
    medium: "40px",
    large: "60px",
  };

  // Inject keyframes CSS once
  useEffect(() => {
    const styleId = "loading-spinner-keyframes";
    if (!document.getElementById(styleId)) {
      const style = document.createElement("style");
      style.id = styleId;
      style.textContent = `
        @keyframes loading-spinner-spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `;
      document.head.appendChild(style);
    }
  }, []);

  return (
    <div
      className={className}
      style={{
        width: sizeMap[size],
        height: sizeMap[size],
        border: "4px solid rgba(255, 255, 255, 0.3)",
        borderTop: "4px solid #ffffff",
        borderRadius: "50%",
        animation: "loading-spinner-spin 1s linear infinite",
      }}
    />
  );
};
